import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=60564456&"
import script from "./Instruction.vue?vue&type=script&lang=js&"
export * from "./Instruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QSpace,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QIcon,QSpace,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn}, component.options.components || {})
